import React from "react";
import ReactTable from "react-table";
import "../../style/helper.css";
import ApiService from "../../Services/ApiService.js";
import {Link} from "react-router-dom";
import LoadingScreen from "../misc/loading.js";
import ErrorScreen from "../misc/error.js";
import AlertService from "../../Services/AlertService";

class Clientlist extends React.Component {
  state = {
    loading: true,
    data: null,
    error: false
  };
  componentDidMount() {
      this.fetchClients();
  }

    onColumnClick = (state, rowInfo, column, instance) => {
        return {
            onClick: e => {

                if (column.Header !== "Action") {
                    let clientId = rowInfo.row.client_id;
                    let clientName = rowInfo.row.client_name;
                    let campaign_url = process.env.REACT_APP_DOMAIN + "/campaigns?client_id=" + clientId + "&client_name=" + clientName;
                    let failure_url = process.env.REACT_APP_DOMAIN + "/clients";
                    let linkedin_auth_url = "/api/linkedin/authenticate?client_id=";
                    let final_url = linkedin_auth_url + clientId+"&success_url="+campaign_url+"&failure_url="+failure_url;
                    ApiService.get(final_url)
                        .then(response => {
                            if(response.data.new_token_needed) {
                                window.location.href = response.data.auth_url;
                            } else {
                                this.props.history.push("/campaigns?client_id="+ clientId + "&client_name=" + clientName)
                            }
                        });
                }
            }
        }
    };
    
    handleEdit = (clientId) => {
        this.props.history.push("/clients/add?client_id=" + clientId);
    };

    handleDelete = (clientId) => {
        if (window.confirm('Are you sure you want to delete this client?')) {
            ApiService.post('/api/clients/delete', {'client_id': clientId})
                .then(response => {
                    this.fetchClients();
                });
        }

    };

    clearToken = (clientId) => {
        ApiService.post('/api/clients/clear-token', {'client_id': clientId})
            .then(response => {
                AlertService.success('Token successfully cleared');
                this.fetchClients();
            })
            .catch(error => {
                AlertService.error('Failed to clear token')
            })
    };

    fetchClients()
    {
        ApiService.get("/api/clients")
            .then(response => {
                this.setState({
                    data: response.data.Clients,
                    loading: false,
                    error: false
                });
            });
    }

  render() {
    const { loading, error, data } = this.state;
    if (loading) {
      return <LoadingScreen/>;
    }
    if (error) {
      return <ErrorScreen/>;
    }
    const columns = [
      {
        Header: "Client ID",
        accessor: "client_id"
      },
      {
        Header: "Client Name",
        accessor: "client_name"
      },
      {
        Header: "Account Name",
        accessor: "account_name"
      },
      {
        Header: "LinkedIn Account",
        accessor: "linkedin_account_id"
      },
        {
            Header: "LinkedIn Organization",
            accessor: "linkedin_organization_id"
        },
        {
            Header: "Account Currency",
            accessor: "account_currency"
        },
        {
            Header: "Start Day",
            accessor: "start_day"
        },
      {
          Header: "Action",
          Cell: (data) => {
              if(data && data.row._original.client_id) {
                  let clientId = data.row._original.client_id;
                  return(
                      <div>
                          <button className="table-btn edit-btn" onClick={() => this.handleEdit(clientId) }> <i className="fa fa-edit"></i> </button>
                          <button className="table-btn" onClick={() => this.handleDelete(clientId)}> <i className="fa fa-trash-o"></i> </button>
                          <button className="table-btn clear-token" title="Clear Token" onClick={() => this.clearToken(clientId)}> <i className="fa fa-ban"></i></button>

                  </div>
              )
              } else {
                  return("");
              }
          }
       }
    ];

      return (
          <div className="page-main">
            <div>
                <button className="add-btn" onClick = {() => {this.props.history.push("/clients/add")}}>
                    Add Client
                 </button>
            </div>

            <div className="page-content">
                <div className="table-style client-list">
                    <ReactTable
                     data={data}
                     columns={columns}
                     showPagination={true}
                     minRows={0}
                     getTdProps={this.onColumnClick}
                    defaultPageSize={50}
                    />
                </div>
             </div>
      </div>
        )
  }
}

export default Clientlist;
